import { DATE_FE_FORMAT, TIME_FORMAT } from '@/constants';
import { ForwardRefExoticComponent, forwardRef } from 'react';
import { IncidentIssueWithCache } from '@/models/gen/graphql';

import { Datetime } from '@/utils';
import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';
import { useIncidentHistoryDrawer } from '@/features/IncidentHistory/components/IncidentHistoryDrawer';
import { useProvider } from '@/common/Provider';

const IncidentFormHistoryTableRow = ({ id }: { id: string }, ref: ForwardRefExoticComponent<HTMLDivElement>): JSX.Element => {
  const [[incidents], , { onEditIncident }] = useProvider<
    { data: Map<string, IncidentIssueWithCache>; driverFirstName: string; driverLastName: string; vehicleTrackingId: string },
    [IncidentIssueWithCache, string, string, string],
    { onEditIncident: (accident: IncidentIssueWithCache) => void }
  >(({ data: incidents, driverFirstName, driverLastName, vehicleTrackingId }) => [
    incidents.get(id) || ({} as IncidentIssueWithCache),
    driverFirstName,
    driverLastName,
    vehicleTrackingId,
  ]);
  const [state, setIncidentHistoryDrawer] = useIncidentHistoryDrawer(({ state, setState }) => [state, setState]);

  const onEdit = (): void => {
    if (onEditIncident) return onEditIncident(incidents);
    setIncidentHistoryDrawer((current) => ({
      ...current,
      show: true,
      data: incidents,
    }));
  };

  return (
    <SimpleTableRow id={id} onDoubleClick={onEdit} ref={ref} className="incidentHistoryRecord" visible>
      <SimpleTableCell name="INCIDENT" className="w-md-grow">
        <span>
          {[incidents.driverFirstName, incidents.driverLastName].join(' ')} - #{incidents.vehicleTrackingId}
        </span>
      </SimpleTableCell>
      <SimpleTableCell name="CREATED_AT">
        <span>{new Datetime(incidents.createdAt).format(DATE_FE_FORMAT)}</span>
        <span>{new Datetime(incidents.createdAt).format(TIME_FORMAT)}</span>
      </SimpleTableCell>
    </SimpleTableRow>
  );
};

export default forwardRef(IncidentFormHistoryTableRow);
